import { useCompanyId } from '@packages/core/company/focused-company-context.ts';
import { useTranslate } from '@tolgee/react';
import { useModalManagerContext } from '@packages/ui/modal/modal-manager-context.ts';
import { ContentLayout, PrimaryContent } from '@packages/ui/content-layout.tsx';
import Card from '@packages/ui/card/card.tsx';
import CardHeader from '@packages/ui/card/card-header.tsx';
import SecondaryButton from '@packages/ui/button/secondary-button.tsx';
import CardTableContent from '@packages/ui/card/card-content-table.tsx';
import StripeApiKeyTable from '@client/page/management/stripe/stripe-api-key/component/stripe-api-key-table.tsx';
import useStripeApiKeys from '@client/page/management/stripe/stripe-api-key/logic/use-stripe-api-keys.ts';
import CreateStripeApiDialog from '@client/page/management/stripe/stripe-api-key/component/create-stripe-api-key-dialog.tsx';
import Loading from '@packages/ui/loading.tsx';
import useCheckAdminRole from '@client/module/auth/check-role-hook.ts';

export default function StripeApiKey() {
  const companyId = useCompanyId();
  const { t } = useTranslate();
  const dialogManager = useModalManagerContext();
  const { isAdmin, isSuperAdmin } = useCheckAdminRole();

  const { data, loading } = useStripeApiKeys(companyId);

  if (loading) {
    return <Loading />;
  }

  if (!data) {
    return <>Data is empty</>;
  }

  if (!isAdmin && !isSuperAdmin) {
    return <>You have not permission</>;
  }

  const createAllergyDialog = () => {
    dialogManager.showDialog((onClose) => <CreateStripeApiDialog onClose={onClose} />);
  };

  return (
    <ContentLayout>
      <PrimaryContent>
        <Card>
          <CardHeader title={t('stripe-api-key.header', 'Stripe api key')}>
            <SecondaryButton onClick={createAllergyDialog} data-testid="list-create-button">
              {t('common.button.create', 'Create')}
            </SecondaryButton>
          </CardHeader>

          <CardTableContent>
            <StripeApiKeyTable apiKey={data.stripeAPIKeys} loading={loading} />
          </CardTableContent>
        </Card>
      </PrimaryContent>
    </ContentLayout>
  );
}
